// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".control-action[data-v-91d2df5c] {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 20px;\n}\n.control-action .title_but[data-v-91d2df5c] {\n  height: 30px;\n  line-height: 30px;\n  margin-left: 5px;\n  padding: 0 9px;\n}\n.control-action .related[data-v-91d2df5c] {\n  color: #1890ff;\n}", ""]);
// Exports
module.exports = exports;
